import React from "react";

interface IPropsTCaption extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

function TCaption({ children, ...props }: IPropsTCaption) {
  return <caption {...props}>{children}</caption>;
}

export default TCaption;
